/** Split persisted story markup into paragraphs by page markers (aligned with WizardContext). */
export function parseStoryParagraphs(storyLanguage: string | undefined, generatedStory?: string): string[] {
  const text = (generatedStory ?? "").trim();
  if (!text) return [];

  const isHebrew = storyLanguage === "Hebrew";
  const pagePattern = isHebrew ? /עמוד\s+\d+\s*:/g : /Page\s+\d+\s*:/gi;
  const parts = text.split(pagePattern);
  const pages = parts.slice(1).map((p) => p.trim()).filter((p) => p.length > 0);
  return pages.length > 0 ? pages : [text];
}
